import ArrowDownConnectionSVG from '@/assets/icons/ArrowDownConnection.svg';
import { Flex } from '..';
import { Image } from './Image';

type Props = {
  width?: number;
  type?: 'raw' | 'flex-wrap';
};

export const ArrowDownImage = ({ width = 32, type = 'flex-wrap' }: Props) => {
  const image = (
    <Image
      src={ArrowDownConnectionSVG}
      alt="connection"
      width={width}
      preview={false}
    />
  );

  if (type === 'flex-wrap') {
    return (
      <Flex justify="center" align="center" style={{ height: '100%' }}>
        {image}
      </Flex>
    );
  }

  return image;
};
